import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserData } from 'app/shared/service/UserService';
import { CryptoService } from 'app/shared/utils/crypto.service';
import * as CryptoJS from "crypto-js";

@Injectable({
  providedIn: 'root'
})
//start SG-8399
export class AuthUserService {
  constructor(private http: HttpClient) { }

  public checkUserAuthForNickNameUser(nickName: string) {
    const url = UserData.backend_url + "/v1/nickNameLogin";
    const postData = {
      "nickName": nickName
    }
    return this.http.post(url, postData); 
  }

  public checkUserAuthForRegisteredUser(token: string, radamKey: string) {
    const url = UserData.backend_url + "/v1/nickNameLogin";
    const postData = {
      "randomKey": radamKey,
      "token": token
    }
    return this.http.post(url, postData); 
  } 
}
//end SG-8399
